import {NgModule} from "@angular/core";
import {EmployeeSearchPageComponent} from "./employee/employee-search-page/employee-search-page.component";
import {SharedModule} from "../shared/shared.module";
import {PositionSearchPageComponent} from "./position/position-search-page/position-search-page.component";
import {AccessRoleSearchPageComponent} from "./access-role/access-role-search-page/access-role-search-page.component";
import {ShiftSearchPageComponent} from "./shift/shift-search-page/shift-search-page.component";
import {FrameworkModule} from "../framework/framework.module";
import {EmployeeEditPageComponent} from "./employee/employee-edit-page/employee-edit-page.component";
import {EmployeeEditEmploymentComponent} from "./employee/employee-edit-page/employee-edit-employment/employee-edit-employment.component";
import {PositionSingleSelectEditControlComponent} from "./position/controls/position-single-select-edit-control.component";
import {PosSharedModule} from "../pos/pos.shared.module";
import {EmployeeEditUserComponent} from "./employee/employee-edit-page/employee-edit-user/employee-edit-user.component";
import {EmployeeSharedModule} from "./employee.shared.module";
import {ContactSharedModule} from "../contact/contact.shared.module";
import {PositionEditPageComponent} from "./position/position-edit-page/position-edit-page.component";
import {AccessRoleEditPageComponent} from "./access-role/access-role-edit-page/access-role-edit-page.component";
import {PrivilegeSelectionComponent} from "./access-role/privilege-selection/privilege-selection.component";
import {ShiftEditPageComponent} from "./shift/shift-edit-page/shift-edit-page.component";
import {EmployeeDetailsReportPageComponent} from "./employee/reports/employee-details-report/employee-details-report-page.component";
import {EmployeePerformanceReportPageComponent} from "./employee/reports/employee-performance-report/employee-performance-report-page.component";
import {EmployeePhonListReportPageComponent} from "./employee/reports/employee-phon-list-report/employee-phon-list-report-page.component";
import {EmployeeTimeCardReportPageComponent} from "./employee/reports/employee-time-card-report/employee-time-card-report-page.component";
import {ReportsSharedModule} from "../reports/reports.shared.module";

@NgModule({
    imports: [
        SharedModule,
        ReportsSharedModule,
        FrameworkModule,
        PosSharedModule,
        ContactSharedModule,
        EmployeeSharedModule
    ],
    declarations: [
        EmployeeEditPageComponent,
        EmployeeEditEmploymentComponent,
        EmployeeEditUserComponent,
        EmployeeSearchPageComponent,
        PositionSearchPageComponent,
        AccessRoleSearchPageComponent,
        AccessRoleEditPageComponent,
        ShiftSearchPageComponent,
        PositionSingleSelectEditControlComponent,
        PositionSingleSelectEditControlComponent,
        PositionEditPageComponent,
        PrivilegeSelectionComponent,
        ShiftEditPageComponent,
        EmployeeDetailsReportPageComponent,
        EmployeePerformanceReportPageComponent,
        EmployeePhonListReportPageComponent,
        EmployeeTimeCardReportPageComponent
    ],
    exports: [
        EmployeeEditPageComponent,
        EmployeeEditEmploymentComponent,
        EmployeeEditUserComponent,
        EmployeeSearchPageComponent,
        PositionSearchPageComponent,
        AccessRoleSearchPageComponent,
        AccessRoleEditPageComponent,
        ShiftSearchPageComponent,
        PositionSingleSelectEditControlComponent,
        PositionSingleSelectEditControlComponent,
        PositionEditPageComponent,
        ShiftEditPageComponent,
        EmployeeDetailsReportPageComponent,
        EmployeePerformanceReportPageComponent,
        EmployeePhonListReportPageComponent,
        EmployeeTimeCardReportPageComponent
    ]
})
export class EmployeeModule {
}
